/**
 * ResumeBanner — gentle "Welcome back" surface when a session is found in
 * localStorage and successfully rehydrated from the backend.
 */
import { RotateCcw } from "lucide-react";

export default function ResumeBanner({ onStartOver }) {
  return (
    <div
      className="kcis-fade-in flex items-center gap-3 px-4 py-3 rounded-2xl bg-purple-50/70 border border-purple-100 text-sm text-purple-900"
      data-testid="kcis-resume-banner"
    >
      <span className="inline-flex h-7 w-7 rounded-full bg-white/70 items-center justify-center shrink-0">
        <RotateCcw className="h-3.5 w-3.5" />
      </span>
      <span className="flex-1">Welcome back — picking up where you left off.</span>
      <button
        type="button"
        onClick={onStartOver}
        className="text-xs underline underline-offset-2 hover:opacity-80"
        data-testid="kcis-resume-start-over"
      >
        Start over
      </button>
    </div>
  );
}
